/**
 * CartFab — floating cart button shown only to staff who can order.
 */
import React from 'react';
import { useOrdering } from './OrderingContext';
import { fmt$ } from './orderApi';

export default function CartFab() {
  const { canOrder, cart, openCart, drawerOpen, checkoutOpen } = useOrdering();
  if (!canOrder || cart.count === 0 || drawerOpen || checkoutOpen) return null;

  return (
    <button className="ord-fab" onClick={openCart} aria-label="Open cart">
      <span className="ord-fab__icon">🛒</span>
      <span className="ord-fab__count">{cart.count}</span>
      <span className="ord-fab__total">{fmt$(cart.subtotal)}</span>
    </button>
  );
}
